<template>
    <section class="py-20 bg-gradient-to-br from-slate-700 to-slate-900 relative overflow-hidden text-white">

        <PatternNew class="absolute top-0 left-0 w-full" :columns="18" :rows="8" variant="outline"
            outlineClass="border-gray-700" :isAnimated="true" />

        <div class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10 relative">
            <div class="text-center mb-12">
                <div class="text-3xl font-headings max-w-xl mx-auto mb-4">
                    {{ title }} work{{ title[title.length - 1] == 's' ? '' : 's' }} seamlessly with the rest of the Entegy platform
                </div>
            </div>

            <div class="max-w-4xl mx-auto">
                <div class="grid grid-cols-1 md:grid-cols-3 md:gap-6 mb-8 bg-white rounded-lg">
                    <router-link v-for="integration in integrations" :key="integration.name" :to="integration.link"
                        class="flex flex-col text-center items-center p-4 rounded-lg hover:bg-gray-50 transition-colors group border border-transparent hover:border-gray-200">


                        <div
                            class="w-9 h-9 shadow-md flex-shrink-0 bg-linear-to-tr from-secondary-500 to-primary-500 border-primary-500 text-white p-1.5 pill-icon transition-all duration-300">
                            <component :is="integration.icon" class="w-6 h-6" />
                        </div>
                        <div class="md:text-sm font-semibold text-gray-900 group-hover:text-primary-600 mt-0.5">
                            {{ integration.name }}
                        </div>
                        <div class="md:text-xs text-gray-500 mt-2">{{ integration.description }}</div>

                    </router-link>
                </div>

                <div class="text-center">
                    <router-link to="/overview"
                        class="inline-flex items-center text-white hover:text-primary-100 font-semibold transition-colors group">
                        <span class="mr-2">Platform Overview</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="w-4 h-4 group-hover:translate-x-1 transition-transform">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import PatternNew from '../PatternNew.vue';
const props = defineProps({
    integrations: {
        type: Array,
        default: () => []
    },
    title: {
        type: String,
    }
})
</script>